import React, { useState, useEffect, MouseEvent, useContext } from 'react'
import { RequestState } from '../../../modules/types'
import { User } from '../../auth/store/store'
import { AppContext } from '../../index'
import { useTranslation } from 'react-i18next'

import { UserMenu } from './UserMenu'

import './PageHeader.css'

export function PageHeader() {
  const { state } = useContext(AppContext)
  const [userMenuOpen, setUserMenuOpen] = useState(false)
  const { user, requestState } = state.auth
  const selectedPartner  = state.partner.currentPartner
  const { t } = useTranslation(['navigation','global'])

  useEffect(() => {
    window.addEventListener('click', () => {
      setUserMenuOpen(false)
    })
  }, [])

  function getAvatar(user: User) {
    function getInitial(str: string) {
      if (str && str.length > 0) {
        return str[0].toLocaleUpperCase()
      } else {
        return ''
      }
    }

    if (user.avatarUrl) {
      return (
        <div>
          <img id="avatar" src={user.avatarUrl} alt="avatar" />
        </div>
      )
    } else {
      const style = {
        backgroundColor: '#' + user.avatarColour
      }

      return (
        <div id="text-avatar" style={style}>
          <span id="avatar-text">
            {getInitial(user.firstName)}
            {getInitial(user.lastName)}
          </span>
        </div>
      )
    }
  }


  function toggleMenu(e: MouseEvent) {
    e.stopPropagation()
    setUserMenuOpen(!userMenuOpen)
  }

  return (
    <header id="page-header">

          {selectedPartner &&
          <h2 id="partner-name">{selectedPartner.name}</h2>
          }

          {!selectedPartner && requestState !== RequestState.Error &&
          <h2>{ t('global:please_wait')}</h2>
          }

          {!selectedPartner && requestState === RequestState.Error &&
          <h2>{t('unable_to_get_partners')}</h2>
          }

          <div id="nav-welcome">
            <span>{user && `${t('hi')} ${user.firstName} `}
            </span>
          </div>

          <div id="nav-user" onClick={toggleMenu}>
            {user && getAvatar(user)}
          </div>

          <UserMenu isOpen={userMenuOpen}/>

      </header>



  )
}
